import { selectTicketTypeByReservation } from '%evp_ticket_frontend/js/redux/currentEvent';
import { selectSeatByHash } from '%paysera_seat_selection/js/seatSelection/redux';
import { OBJECT_TYPE_SEAT } from '%paysera_seat_selection/js/seatSelection/config/constants';
import doSetReservationSeatAsAvailable from './original/setReservationSeatAsAvailable';

function setSubscriptionsOnSaleAsAvailable(seatings) {
    return (dispatch, getState) => {
        seatings
            .filter(seating => seating.type === OBJECT_TYPE_SEAT)
            .forEach((seating) => {
                const { reservation } = selectSeatByHash(getState(), seating.hash);
                const technicalTicketType = selectTicketTypeByReservation(getState(), reservation.hash);
                dispatch(doSetReservationSeatAsAvailable({
                    seating: {
                        hash: seating.hash,
                        objectType: seating.type,
                    },
                    ticketType: {
                        color: reservation.color,
                        hash: technicalTicketType.hash,
                    },
                }));
            });
    };
}

export default setSubscriptionsOnSaleAsAvailable;
